/**
 * Shared inline-style overrides for `reactjs-popup` <Popup> instances so
 * every popup built on that library gets the same overlay/content chrome
 * as PopupShell (see PopupShell.css) — dark blurred backdrop, and a content
 * box with no built-in padding/border/shadow so the inner markup's own
 * `.header`/`.body` sections (styled to match popupShellHeader/popupShellBody)
 * control the look.
 */
export const POPUP_OVERLAY_STYLE = {
  backgroundColor: 'rgba(30, 16, 64, 0.6)',
  backdropFilter: 'blur(8px)',
  WebkitBackdropFilter: 'blur(8px)',
};

export const popupContentStyle = (extra = {}) => ({
  padding: 0,
  border: 'none',
  background: 'transparent',
  borderRadius: 0,
  boxShadow: 'none',
  ...extra,
});
